
import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Sidebar({ onNavigate }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [hoveredItem, setHoveredItem] = useState(null);

  const handleLogout = async () => {
    if (typeof onNavigate === "function") onNavigate();
    await logout();
    navigate("/login");
  };

  const getLinkStyle = (isActive, itemName) => {
    const isHovered = hoveredItem === itemName;

    return {
      backgroundColor: isActive ? "#4f46e5" : isHovered ? "var(--surface-soft)" : "transparent",
      color: isActive ? "#ffffff" : isHovered ? "var(--text)" : "var(--text-muted)",
      boxShadow: isActive ? "0 10px 20px rgba(79, 70, 229, 0.2)" : "none",
    };
  };

  const linkClassName = "block rounded-xl px-3 py-2.5 text-sm font-medium transition-all duration-200";

  return (
    <div className="flex h-full w-72 flex-col border-r p-5 shadow-2xl md:w-64" style={{ backgroundColor: 'var(--app-bg)', color: 'var(--text)', borderColor: 'var(--border)' }}>
      <div className="mb-6 rounded-2xl border p-3" style={{ backgroundColor: 'var(--surface-soft)', borderColor: 'var(--border)', color: 'var(--text)' }}>
        <p className="text-xs font-semibold uppercase tracking-[0.3em]" style={{ color: 'var(--text-muted)' }}>Menu</p>
        <h3 className="mt-1 text-xl font-semibold" style={{ color: 'var(--text)' }}>Dashboard</h3>
      </div>

      {(user?.role === "user" || user?.role === "admin") && (
        <NavLink
          to="/dashboard"
          className={linkClassName}
          onClick={onNavigate}
          onMouseEnter={() => setHoveredItem("dashboard")}
          onMouseLeave={() => setHoveredItem(null)}
          style={({ isActive }) => getLinkStyle(isActive, "dashboard")}
        >
          Dashboard
        </NavLink>
      )}

      {(user?.role === "user" || user?.role === "admin") && (
        <NavLink
          to="/kot-management"
          className={linkClassName}
          onClick={onNavigate}
          onMouseEnter={() => setHoveredItem("kot-management")}
          onMouseLeave={() => setHoveredItem(null)}
          style={({ isActive }) => getLinkStyle(isActive, "kot-management")}
        >
          KOT Management
        </NavLink>
      )}


      {(user?.role === "superadmin") && (
        <NavLink
          to="/admin"
          className={linkClassName}
          onClick={onNavigate}
          onMouseEnter={() => setHoveredItem("admin")}
          onMouseLeave={() => setHoveredItem(null)}
          style={({ isActive }) => getLinkStyle(isActive, "admin")}
        >
          Admin Panel
        </NavLink>
      )}

      {(user?.role === "superadmin") && (
        <NavLink
          to="/sales-report"
          className={linkClassName}
          onClick={onNavigate}
          onMouseEnter={() => setHoveredItem("sales-report")}
          onMouseLeave={() => setHoveredItem(null)}
          style={({ isActive }) => getLinkStyle(isActive, "sales-report")}
        >
          Sales Report
        </NavLink>
      )}

      {user?.role === "superadmin" && (
        <NavLink
          to="/products"
          className={linkClassName}
          onClick={onNavigate}
          onMouseEnter={() => setHoveredItem("products")}
          onMouseLeave={() => setHoveredItem(null)}
          style={({ isActive }) => getLinkStyle(isActive, "products")}
        >
          Products
        </NavLink>
      )}

      {user?.role === "superadmin" && (
        <NavLink
          to="/product-categories"
          className={linkClassName}
          onClick={onNavigate}
          onMouseEnter={() => setHoveredItem("product-categories")}
          onMouseLeave={() => setHoveredItem(null)}
          style={({ isActive }) => getLinkStyle(isActive, "product-categories")}
        >
          Product Categories
        </NavLink>
      )}

      

      {(user?.role === "admin" || user?.role === "superadmin") && (
        <NavLink
          to="/pendingbill"
          className={linkClassName}
          onClick={onNavigate}
          onMouseEnter={() => setHoveredItem("pendingbill")}
          onMouseLeave={() => setHoveredItem(null)}
          style={({ isActive }) => getLinkStyle(isActive, "pendingbill")}
        >
          Pending Bills
        </NavLink>
      )}

      {(user?.role === "admin" || user?.role === "superadmin") && (
        <NavLink
          to="/attendance"
          className={linkClassName}
          onClick={onNavigate}
          onMouseEnter={() => setHoveredItem("attendance")}
          onMouseLeave={() => setHoveredItem(null)}
          style={({ isActive }) => getLinkStyle(isActive, "attendance")}
        >
          Attendance
        </NavLink>
      )}

      {/* {(user?.role === "admin" || user?.role === "superadmin") && (
        <NavLink
          to="/account"
          className={linkClassName}
          onClick={onNavigate}
          onMouseEnter={() => setHoveredItem("account")}
          onMouseLeave={() => setHoveredItem(null)}
          style={({ isActive }) => getLinkStyle(isActive, "account")}
        >
          Account Ledger
        </NavLink>
      )} */}

      {/* {(user?.role === "admin" || user?.role === "superadmin") && (
        <NavLink
          to="/salary-master"
          className={linkClassName}
          onClick={onNavigate}
          onMouseEnter={() => setHoveredItem("salary-master")}
          onMouseLeave={() => setHoveredItem(null)}
          style={({ isActive }) => getLinkStyle(isActive, "salary-master")}
        >
          Salary Master
        </NavLink>
      )} */}

      <div className="mt-auto rounded-2xl border p-3" style={{ backgroundColor: 'var(--surface-soft)', borderColor: 'var(--border)' }}>
        <p className="text-sm" style={{ color: 'var(--text-muted)' }}>Welcome: <span className="font-semibold" style={{ color: 'var(--text)' }}>{user?.firstname}  {user?.lastname}</span></p>
        <p className="text-sm" style={{ color: 'var(--text-muted)' }}>Role: {user?.role === 'admin' ? 'Manager': (user?.role === 'user' ? 'Waiters' : 'SuperAdmin') } </p>

        <button
          onClick={handleLogout}
          className="mt-3 w-full rounded-xl bg-rose-500/90 px-3 py-2 text-sm font-semibold text-white transition hover:bg-rose-600"
        >
          Logout
        </button>
      </div>
    </div>
  );
}
